<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Formatos</h1>
          <b-spinner v-if="loading" variant="primary" class="ml-2" small label="Small Spinner"></b-spinner>
        </b-col>
        <b-col>
          <b-button class="float-right" :href="baseUrl + '/admin/production/container/add'" target="_blank"
            >Crear formato <i class="fa fa-ga fa-external-link ml-1"></i
          ></b-button>
          <b-button v-b-modal.modal-1 class="float-right mr-1" 
            >Diccionario</b-button>
            <b-modal id="modal-1" title="Diccionario" header-bg-variant="light" ok-only>
              <strong>ESPECIE:</strong> (B) Blueberries, (C) Cherries, (S) Strawberries, ... <br>
              <strong>PLANTA </strong>OPERACION: (I) Imperial Farm, (J) San Javier, (B) Broom, ...<br>
              <strong>CONDICION:</strong> (C) Convencional, (O) Organico <br>
              <strong>- </strong> <br>
              <strong>ETIQUETA:</strong> (0) Genérica, (1) CAL GIANT, ... <br>
              <strong>FORMATO:</strong> (0) 6OZ, (1) PINTA, (2) 8LB, (3) BULK, (4) 4.4OZ, (5) 18OZ <br>
              <strong>ENVIO:</strong> (0) Aereo, (1) CTN, (2) CAMARA, (3) Terrestre <br>
            </b-modal>
        </b-col>
      </b-row>

      <v-client-table :data="tableData" :columns="columns" :options="options" v-if="ready">
        <template #protocol_file="props">
          <a :href="baseUrl + props.row.protocol_file" target="_blank" v-if="props.row.protocol_file">Ver</a>
        </template>
        <template slot="child_row" slot-scope="props" >
          <div class="ml-5">

            <span  style="white-space: pre-line">{{ props.row.description }}</span>
          </div>
        </template>
        <template #m&s_t="props">
          <a href="#" target="_blank">
            <formatos-modal-mys :modalId="'mod-for-' + props.row.id"></formatos-modal-mys>
          </a>
        </template>
        <template #sku="props">

            <a href="#" v-b-modal="'modal-desc-'+props.row.id" class="text-center" variant="link">{{ props.row.sku }}</a>
          <b-modal :id="'modal-desc-'+props.row.id" title="Definición" header-bg-variant="light" ok-only>
            <span style="white-space: pre-line">

              {{ props.row.description }}
            </span>
            </b-modal>
        </template>
        <template #m&s_o="props">
          <a href="#" target="_blank">2.3</a>
        </template>
        <template #bulk="props">
          <span v-if="props.row.bulk == 1">Si</span>
          <span v-else>No</span>
        </template>
        <template #actions="props">
          <b-dropdown size="sm" variant="link" no-caret dropleft>
            <template #button-content>
              <i class="fa fa-ga fa-chevron-down"></i>
            </template>
            <b-dropdown-item :href="baseUrl + '/admin/production/container/' + props.row.id" target="_blank"
              >Editar <i class="fa fa-ga fa-external-link ml-1"></i>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FormatosModalMys from "./FormatosModalMys.vue";
export default {
  name: "Formatos",
  components: {
    FormatosModalMys
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      ready: false,
      loading: true,
      columns: [
        "name",
        "sku",
        "net_weight",
        "gross_weight",
        "bulk",
        "protocol_file",
        "gtin",
        "voz1",
        "voz2",
        "total_boxes",
        // "m&s_t",
        // "m&s_o",
        "actions"
        // {
        //   name: "name",
        //   title: "Nombre"
        // },
        // {
        //   name: "sku",
        //   title: "SKU"
        // },
        // {
        //   name: "description",
        //   title: "Descripción"
        // }
      ],
      tableData: [],
      options: {
        headings: {
          protocol_file: "Ficha",
          "m&s_t": "M&S T",
          "m&s_o": "M&S O",
          actions: "Acciones"
        },
        columnsClasses: {
          protocol_file: "w-5 text-center",
          "m&s_t": "w-5 text-center",
          "m&s_o": "w-5 text-center",
          actions: "w-5 text-center"
        },
        childRow: true,
        filterByColumn: true,

      }
    };
  },
  filters: {
    datetime(value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  methods: {
    async getData() {
      try {
        const response = await this.$axios.get("/api/v1/container/all_not_bulk/");
        this.tableData = response.data;
        // this.columns = Object.keys(response.data[0]);
        // this.columns.push("actions");
        this.ready = true;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.ready = true;
        this.loading = false;
      }
    }
  },
  mounted() {
    moment.locale("es");
    this.getData();
  }
};
</script>

<style scoped>
#dataTable {
  width: 100%;
  margin: 0 auto;
}
  
  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
</style>
